import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A risk-zone chip: colour fill + translated zone name + icon.
 *
 * Colour is never the sole carrier of meaning — the label and the icon always
 * ship with it. Text is `black-landing` on every fill; see landingConfig.js for
 * the verified contrast ratios (all four pass AA against #121233, whereas white
 * on the red fill would only reach 3.9:1).
 *
 * Labels come from the app's existing `zones.*_zone` keys, so the wording here
 * matches the product exactly.
 */

const SIZES = {
  sm: { wrap: "gap-1.5 rounded-md px-2 py-1 text-xs", icon: "h-3.5 w-3.5" },
  md: { wrap: "gap-2 rounded-lg px-3 py-1.5 text-sm", icon: "h-4 w-4" },
};

export default function RiskZoneBadge({
  zone,
  count,
  size = "md",
  className = "",
}) {
  const { t } = useTranslation();
  const { code, bg, Icon } = zone;
  const s = SIZES[size] || SIZES.md;

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap font-medium text-black-landing ${s.wrap} ${bg} ${className}`}
    >
      <Icon className={`${s.icon} shrink-0`} aria-hidden="true" />
      <span>{t(`zones.${code}`)}</span>
      {count != null && <span className="tabular-nums">{count}</span>}
    </span>
  );
}
